import { DefaultOptionType } from 'antd/lib/select';

import { initOfferIdentitiesSuccessAction, updateOfferSelectedItemAction } from 'containers/Offers/Offer/store';

import { OfferItemDetails, OfferItemIdentity } from 'codegen';
import { IDataResponse, TFieldProps } from 'types';

export const fields = (
  options?: DefaultOptionType[],
): TFieldProps[] => [{
  options,
  type: TFieldProps.type.Select,
  label: 'Name',
  name: 'selectedItemId',
  onSelectChange: updateOfferSelectedItemAction,
}];

export const getFormattedIdentities = (identity: OfferItemIdentity) => ({
  ...identity,
  merchants: identity.merchants.map((merchant) => ({ ...merchant, label: merchant.name, value: `${merchant.id}-${merchant.company.id}` })),
});

export const handleSuccessGetOfferItemDetails = (
  { data }: IDataResponse<OfferItemDetails>,
) => {
  const identities = data.identities?.map(getFormattedIdentities) || [];

  initOfferIdentitiesSuccessAction(identities);
};
